function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { isEmpty } from '@fe-util/common';
import { Select } from 'antd';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import "./index.less";
var Option = Select.Option;
var DatePickerInput = function DatePickerInput(_ref) {
  var className = _ref.className,
    style = _ref.style,
    disabled = _ref.disabled,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    onChange = _ref.onChange,
    _ref$linkage = _ref.linkage,
    linkage = _ref$linkage === void 0 ? true : _ref$linkage,
    _ref$requiredType = _ref.requiredType,
    requiredType = _ref$requiredType === void 0 ? 'day' : _ref$requiredType,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? {
      year: 'YYYY',
      month: 'MM',
      day: 'DD'
    } : _ref$placeholder,
    _ref$monthOptions = _ref.monthOptions,
    monthOptions = _ref$monthOptions === void 0 ? [{
      value: '01',
      label: '01'
    }, {
      value: '02',
      label: '02'
    }, {
      value: '03',
      label: '03'
    }, {
      value: '04',
      label: '04'
    }, {
      value: '05',
      label: '05'
    }, {
      value: '06',
      label: '06'
    }, {
      value: '07',
      label: '07'
    }, {
      value: '08',
      label: '08'
    }, {
      value: '09',
      label: '09'
    }, {
      value: '10',
      label: '10'
    }, {
      value: '11',
      label: '11'
    }, {
      value: '12',
      label: '12'
    }] : _ref$monthOptions,
    _ref$yearOptions = _ref.yearOptions,
    yearOptions = _ref$yearOptions === void 0 ? [] : _ref$yearOptions;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    year = _useState2[0],
    setYear = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    month = _useState4[0],
    setMonth = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    day = _useState6[0],
    setDay = _useState6[1];

  // 年份选项 (1990-当前年份+5)
  var currentYear = new Date().getFullYear();
  var yearList = isEmpty(yearOptions) || yearOptions.length <= 0 ? Array.from({
    length: 100
  }, function (_, i) {
    return {
      value: currentYear + 5 - i,
      label: currentYear + 5 - i
    };
  }) : yearOptions;
  // 天数选项 (1-31，不考虑月份)
  var allDayOptions = Array.from({
    length: 31
  }, function (_, i) {
    return {
      value: (i + 1).toString().padStart(2, '0'),
      label: (i + 1).toString().padStart(2, '0')
    };
  });

  // 根据年份和月份计算天数
  var getDayOptions = function getDayOptions(selectedYear, selectedMonth) {
    if (!selectedYear || !selectedMonth) return [];
    var yearNum = parseInt(selectedYear);
    var monthNum = parseInt(selectedMonth);
    var daysInMonth = new Date(yearNum, monthNum, 0).getDate();
    return Array.from({
      length: daysInMonth
    }, function (_, i) {
      return {
        value: (i + 1).toString().padStart(2, '0'),
        label: (i + 1).toString()
      };
    });
  };
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    dayOptions = _useState8[0],
    setDayOptions = _useState8[1];

  // 触发外部onChange
  var triggerChange = function triggerChange(y, m, d) {
    if (requiredType === 'year') {
      if (y && m && d) {
        onChange === null || onChange === void 0 || onChange("".concat(y, "-").concat(m, "-").concat(d));
      } else if (y && m) {
        onChange === null || onChange === void 0 || onChange("".concat(y, "-").concat(m));
      } else if (y) {
        onChange === null || onChange === void 0 || onChange(y);
      } else {
        onChange === null || onChange === void 0 || onChange();
      }
    }
    if (requiredType === 'month') {
      if (y && m && d) {
        onChange === null || onChange === void 0 || onChange("".concat(y, "-").concat(m, "-").concat(d));
      } else if (y && m) {
        onChange === null || onChange === void 0 || onChange("".concat(y, "-").concat(m));
      } else {
        onChange === null || onChange === void 0 || onChange();
      }
    }
    if (requiredType === 'day') {
      if (y && m && d) {
        onChange === null || onChange === void 0 || onChange("".concat(y, "-").concat(m, "-").concat(d));
      } else {
        onChange === null || onChange === void 0 || onChange();
      }
    }
  };

  // 解析初始值

  useEffect(function () {
    if (value) {
      var _value$split = value.split('-'),
        _value$split2 = _slicedToArray(_value$split, 3),
        y = _value$split2[0],
        m = _value$split2[1],
        d = _value$split2[2];
      setYear(y || '');
      setMonth(m || '');
      setDay(d || '');
      if (y && m && linkage) {
        setDayOptions(getDayOptions(y, m));
      } else {
        setDayOptions(allDayOptions);
      }
    }
  }, [value]);

  // 更新天数选项当月变化时

  useEffect(function () {
    if (linkage) {
      if (year && month) {
        var days = getDayOptions(year, month);
        setDayOptions(days);

        // 如果当前选择的day不在新月份的天数范围内，则重置day

        if (day && !days.some(function (d) {
          return d.value === day;
        })) {
          setDay('');
          triggerChange(year, month, '');
        }
      } else {
        setDayOptions([]);
      }
    } else {
      setDayOptions(allDayOptions);
    }
  }, [year, month, linkage]);
  var handleYearChange = function handleYearChange(value) {
    setYear(value);
    triggerChange(value, month, day);
  };
  var handleMonthChange = function handleMonthChange(value) {
    setMonth(value);
    triggerChange(year, value, day);
  };
  var handleDayChange = function handleDayChange(value) {
    setDay(value);
    triggerChange(year, month, value);
  };
  var componentClass = classNames(className, 'iron-datePickerInput');
  return /*#__PURE__*/React.createElement("div", {
    className: componentClass,
    style: style
  }, /*#__PURE__*/React.createElement(Select, {
    placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.year,
    value: year || undefined,
    onChange: handleYearChange,
    showSearch: true,
    allowClear: true,
    disabled: disabled,
    dropdownMatchSelectWidth: false
    // filterOption={(input: string, option: any) =>
    //   option &&
    //   option.children &&
    //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    // }
  }, yearList.map(function (y) {
    return /*#__PURE__*/React.createElement(Option, {
      key: y.value,
      value: y.value.toString()
    }, y.value);
  })), /*#__PURE__*/React.createElement(Select, {
    placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.month,
    value: month || undefined,
    onChange: handleMonthChange,
    showSearch: true,
    allowClear: true,
    disabled: disabled,
    dropdownMatchSelectWidth: false
    // filterOption={(input: string, option: any) =>
    //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    // }
  }, monthOptions.map(function (m) {
    return /*#__PURE__*/React.createElement(Option, {
      key: m.value,
      value: m.value
    }, m.label);
  })), /*#__PURE__*/React.createElement(Select, {
    placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.day,
    value: day || undefined,
    onChange: handleDayChange,
    disabled: disabled ? disabled : (!year || !month) && linkage,
    showSearch: true,
    allowClear: true,
    dropdownMatchSelectWidth: false
  }, dayOptions.map(function (d) {
    return /*#__PURE__*/React.createElement(Option, {
      key: d.value,
      value: d.value
    }, d.label);
  })));
};
export default DatePickerInput;